import { SimpleChanges } from '@angular/core';
import {
  Component,
  Input,
  forwardRef,
  HostListener,
  ElementRef,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";

@Component({
  selector: "ema-select-search",
  templateUrl: "./ema-select-search.component.html",
  styleUrls: ["./ema-select-search.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EmaSelectSearchComponent),
      multi: true,
    },
  ],
})
export class EmaSelectSearchComponent implements ControlValueAccessor {
  list = [];
  items_original = [];
  temp_list = [];
  keyword = "";
  _img: any;
  _label: any;
  _uid: any;

  @Output() afterChange = new EventEmitter();
  @Output() changeDetect = new EventEmitter<any>();
  @Output() notFoundEvent = new EventEmitter<any>();
  @ViewChild("input", { static: false }) input: ElementRef;
  @Input("size") size;
  @Input("items") set items(value) {

    if (!value || !Array.isArray(value)) return;

    // 🔥 SI YA TENÍAS DATOS Y VIENE VACÍO → IGNORAR
    if (value.length == 0 && this.items_original.length > 0) {
      return;
    }

    this.items_original = value;
    this.temp_list = value;
    this.list = value;
  }
  @Input() enableReset: boolean = false; // 🔥 por defecto NO hace nada
  @Input() resetTrigger: any;
  @Input("img") img;
  @Input("label") label;
  @Input("uid") uid;
  onChange: any = () => { };
  onTouch: any = () => { };
  value: any = "Select";
  shown = false;
  constructor(private ele: ElementRef) { }
  ngOnChanges(changes: SimpleChanges) {

    this._label = this.label != null && this.label !== "" ? this.label : "name";
    this._img = this.img != null && this.img !== "" ? this.img : "img";
    this._uid = this.uid != null && this.uid !== "" ? this.uid : "id";

    if (!this.value) {
      this.value = "Select";
    }

    // 🔥 SOLO si está activado
    if (!this.enableReset) return;

    if (
      changes.resetTrigger &&
      !changes.resetTrigger.firstChange &&
      this.items_original &&
      this.items_original.length > 0
    ) {
      this.reset();
    }
  }
  writeValue(value) {
    if (value) {
      this.temp_list.map((x) => {
        if (x[this._uid] == value) {
          this.value = x[this._label];
        }
      });
    }
  }
  registerOnChange(fn: any) {
    //console.log("Registering changes----");
    this.onChange = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }
  search(e) {

    let val = "";

    if (e != null && e != undefined) {
      val = e.toLowerCase().trim();
    }

    // 🔹 restaurar si vacío
    if (val == "") {
      this.list = [...this.items_original];
      this.notFoundEvent.emit(true);
      return;
    }

    const filtered = [];

    for (let i = 0; i < this.items_original.length; i++) {

      const x = this.items_original[i];

      let label = "";

      if (x[this._label] != null) {
        label = x[this._label].toString().toLowerCase();
      }

      if (label.indexOf(val) != -1) {
        filtered.push(x);
      }
    }

    this.list = filtered;

    this.notFoundEvent.emit(filtered.length != 0);
  }

  select(item) {
    //console.log("item seleccionado.", item);
    //this.onChange(item[this._label]);
    this.onChange(item);
    this.value = item[this._label];
    this.shown = false;
    this.changeDetect.emit(item);
  }
  show() {

    this.shown = !this.shown;

    if (this.shown && this.enableReset) {
      this.keyword = '';
      this.list = [...this.items_original];
    }

    setTimeout(() => {
      this.input.nativeElement.focus();
    }, 200);
  }
  @HostListener("document:click", ["$event"]) onClick(e) {
    // console.log("Seleccionando.....");
    if (!this.ele.nativeElement.contains(e.target)) {
      this.shown = false;
    }
  }
  reset() {

    if (!this.enableReset) return; // 🔥 protección extra

    this.keyword = '';
    this.list = [...this.items_original];
    this.temp_list = [...this.items_original];
    this.value = 'Select';
    this.shown = false;
  }
}
